import React, { Component } from "react";
//container pages
import RegPage from "./pages/regPage";
import FormUnavailable from "./pages/formUnavailablePage";
//importing API calls functions
import Connector from "./utils/api/Connector";

import Wait from "@react/react-spectrum/Wait";
import AppErrorPage from "../components/errors/AppErrorPage";
import { normalizeApiErrorMessages } from "../components/errors";
import {
  setGeoPolData,
  setCountryStateMappingData,
} from "../actions/commonActions";
// // import geoPolData from './config/geoPolData';
import { connect } from "react-redux";
import { getGeoPolData } from "../getGeoPolDataApi";
import { getCountryStateMappingData } from "../getCountryStateMappingDataApi";

class RegApp extends Component {
  constructor(props) {
    super(props);
    this.connector = new Connector();
  }

  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.connector.searchEmail(this.onSearchComplete);
    getGeoPolData(this.props.setGeoPolDataAction);
  }

  onSearchComplete = async (data) => {
    const cntryData = await getCountryStateMappingData();
    if (cntryData && Object.keys(cntryData)?.length > 0) {
      this.props.setCountryStateMappingDataAction(cntryData);
      this.setState({ data: data, isLoading: false });
    }
  };

  render() {
    return (
      <div>
        {this.state.isLoading ||
        !Object.keys(this.props.geoPolData || {}).length ? (
          <Wait size="L" centered />
        ) : this.state.data.isError ? (
          <AppErrorPage
            title="Unable to load this page"
            errorPayload={this.state.data}
            messages={normalizeApiErrorMessages(this.state.data)}
          />
        ) : this.state.data.code ? (
          this.state.data.code === "10004" &&
          this.state.data.isPartnerContact &&
          this.state.data.partialRegistration &&
          this.state.data.emailExists &&
          this.state.data.programType === "APC" ? (
            <RegPage searchData={this.state.data} connector={this.connector} />
          ) : (
            <FormUnavailable searchData={this.state.data} />
          )
        ) : (
          <RegPage searchData={this.state.data} connector={this.connector} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  geoPolData: state.common.geoPolData,
});

const mapDispatchToProps = (dispatch) => ({
  setGeoPolDataAction: (e) => dispatch(setGeoPolData(e)),
  setCountryStateMappingDataAction: (e) =>
    dispatch(setCountryStateMappingData(e)),
});
export default connect(mapStateToProps, mapDispatchToProps)(RegApp);
